import React, { useEffect, useState } from "react";
import "../css/donations.scss";
import { get_dontion_list } from "../apis/GetDontionList.js";
import { LIST_URL } from "../constans/ApiEndpointConstants.js";
import { useNavigate } from "react-router-dom";
import Loading from "./common/Loading.js";
import { generateDonationUrl } from "../utils/urlUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

const Donations = () => {
  const [donationsData, setDonationsData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  // 获取捐款列表计算动态数据
  useEffect(() => {
    const fetchOrderDonations = async () => {
      setLoading(true);
      try {
        const response = await get_dontion_list("1", "20000", "JP");
        const orders = response?.data ?? response ?? [];
        const projectList = orders.projects;

        // Ensure we have an array and shuffle it so the display order is random
        const rawList = Array.isArray(projectList)
          ? projectList.slice()
          : Array.isArray(orders)
          ? orders.slice()
          : [];

        const shuffleArray = (arr) => {
          for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            const tmp = arr[i];
            arr[i] = arr[j];
            arr[j] = tmp;
          }
          return arr;
        };

        // Take only first 4 items for the featured section
        setDonationsData(shuffleArray(rawList).slice(0, 4));
      } catch (error) {
        console.error("Failed to fetch order list:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDonations();
  }, []);

  const parseAmount = (val) => {
    if (val == null) return 0;
    if (typeof val === "number") return val;
    const s = String(val).replace(/[^0-9.-]+/g, "");
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  };

  const computeProgress = (item) => {
    if (!item) return 0;
    if (typeof item.progress === "number")
      return Math.max(0, Math.min(1, item.progress));
    const raised = parseAmount(
      item.raised ?? item.raised_amount ?? item.raisedAmount
    );
    const goal = parseAmount(item.goal ?? item.goal_amount ?? item.goalAmount);
    if (goal > 0) return Math.max(0, Math.min(1, raised / goal));
    return 0;
  };

  const resolveImageUrl = (raw) => {
    if (!raw) return "";
    if (/^https?:\/\//i.test(raw) || raw.startsWith("data:")) return raw;
    const base = LIST_URL.endsWith("/") ? LIST_URL.slice(0, -1) : LIST_URL;
    return raw.startsWith("/") ? base + raw : base + "/" + raw;
  };

  if (loading) {
    return (
      <div className="donations">
        <Loading />
      </div>
    );
  }

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="donations">
      <div className="donations__inner">
        <div className="donations__header">
          <h2 className="donations__title">注目のプロジェクト</h2>
          <button
            className="donations__more"
            onClick={() => {
              navigate("/donations");
              toTop();
            }}
          >
            もっと見る <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>

        <div className="donations__grid">
          {donationsData.map((item, index) => (
            <article
              key={index}
              className="donations__card"
              onClick={() => {
                const url = generateDonationUrl(item);
                if (url) navigate(url);
              }}
            >
              <div className="card">
                <div className="card__img-wrap">
                  <img
                    src={resolveImageUrl(
                      item.image?.[0]?.url || item.img || ""
                    )}
                    alt={item.title}
                  />
                  {/* Mock badges based on index or data */}
                  {index === 0 && (
                    <span className="badge badge--orange">NEXT GOAL挑戦中</span>
                  )}
                  {index === 2 && (
                    <span className="badge badge--red">達成</span>
                  )}
                </div>
                <h3 className="card__title">{item.title}</h3>
                <div className="card__organizer">
                  {/* Placeholder for organizer info since it might not be in API response directly */}
                  <div className="organizer-icon">
                    {item.avatar ? (
                      <img
                        src={resolveImageUrl(item.avatar)}
                        alt=""
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "50%",
                        }}
                      />
                    ) : (
                      <svg
                        t="1763521333448"
                        className="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="2441"
                        width="100%"
                        height="100%"
                      >
                        <path
                          d="M506.4704 606.0032a204.8 204.8 0 1 1 201.5232-204.8 203.5712 203.5712 0 0 1-201.5232 204.8z m0-386.4576a181.4528 181.4528 0 1 0 177.8688 181.3504 179.9168 179.9168 0 0 0-177.8688-181.4528z"
                          p-id="2442"
                        ></path>
                        <path
                          d="M506.4704 611.1232a210.2272 210.2272 0 1 1 206.6432-210.2272 208.6912 208.6912 0 0 1-206.6432 210.2272z m0-409.6a199.9872 199.9872 0 1 0 196.4032 199.3728 198.4512 198.4512 0 0 0-196.4032-199.8848z m0 386.4576a186.5728 186.5728 0 1 1 182.9888-187.0848 185.0368 185.0368 0 0 1-182.9888 186.5728z m0-362.9056a176.3328 176.3328 0 1 0 172.7488 175.8208 174.7968 174.7968 0 0 0-172.7488-176.3328z"
                          p-id="2443"
                        ></path>
                        <path
                          d="M771.7888 812.8512a11.776 11.776 0 0 1-11.264-8.3968 264.704 264.704 0 0 0-508.2112 0 11.776 11.776 0 1 1-22.528-6.8608 288.3584 288.3584 0 0 1 552.96 0 11.776 11.776 0 0 1-11.264 15.2576z"
                          p-id="2444"
                        ></path>
                        <path
                          d="M241.0496 817.9712A16.896 16.896 0 0 1 225.28 796.16a293.4784 293.4784 0 0 1 563.2 0 16.896 16.896 0 0 1-11.264 21.0944 17.2032 17.2032 0 0 1-21.0944-11.264 259.584 259.584 0 0 0-498.3808 0 16.9984 16.9984 0 0 1-16.6912 11.9808z m265.4208-222.3104A283.8528 283.8528 0 0 0 234.5984 798.72a6.656 6.656 0 1 0 12.8 3.8912 269.824 269.824 0 0 1 518.0416 0 6.9632 6.9632 0 0 0 8.2944 4.4032A6.656 6.656 0 0 0 778.24 798.72a283.8528 283.8528 0 0 0-271.7696-203.0592z"
                          p-id="2445"
                        ></path>
                      </svg>
                    )}
                  </div>
                  <span>{item.name || "主催者"}</span>
                </div>

                <div className="card__stats">
                  <div className="progress-bar">
                    <div
                      className="progress-bar__fill"
                      style={{ width: `${computeProgress(item) * 100}%` }}
                    >
                      <span className="progress-bar__text">
                        {Math.round(computeProgress(item) * 100)}%
                      </span>
                    </div>
                  </div>
                  <div className="stats-row details">
                    <div className="stat-item">
                      <span className="label">現在</span>
                      <span className="value">
                        {parseAmount(
                          item.raised ?? item.raised_amount ?? item.raisedAmount
                        ).toLocaleString("en", { maximumFractionDigits: 0 })}
                        円
                      </span>
                    </div>
                    <div className="stat-item">
                      <span className="label">支援者</span>
                      <span className="value">
                        {item.supporters || Math.floor(Math.random() * 1000)}人
                      </span>
                    </div>
                    <div className="stat-item">
                      <span className="label">残り</span>
                      <span className="value">
                        {item.daysLeft || Math.floor(Math.random() * 30)}日
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Donations;
